import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ArrowUpRight, Menu, Phone, X } from "lucide-react";
import { LOGO_URL, track } from "../lib/site";
import { useSite } from "../context/SiteContext";

const LINKS = [
  { to: "/rooms", label: "Rooms & Suites", id: "rooms" },
  { to: "/spa", label: "Resort & Spa", id: "spa" },
  { to: "/dining", label: "Dining", id: "dining" },
  { to: "/experiences", label: "Experiences", id: "experiences" },
  { to: "/offers", label: "Offers", id: "offers" },
  { to: "/gallery", label: "Gallery", id: "gallery" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const { openBooking, settings } = useSite();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="announcement" data-testid="announcement-bar">
        {settings.announcement || "Book direct for the best available rate"} <span>·</span> Reservations {settings.phone_display}
      </div>
      <header className={scrolled ? "navbar scrolled" : "navbar"} data-testid="main-header">
        <Link to="/" className="brand" data-testid="brand-link">
          <img className="brand-logo" src={LOGO_URL} alt="Madhubhan Resort & Spa" />
        </Link>
        <nav className={open ? "nav-links open" : "nav-links"} data-testid="main-navigation">
          {LINKS.map((link) => (
            <NavLink key={link.to} to={link.to} data-testid={`nav-${link.id}`}>
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="nav-actions">
          <a
            className="phone-link"
            href={`tel:${settings.phone_tel}`}
            onClick={() => track("call_click", { location: "navbar" })}
            data-testid="nav-phone"
          >
            <Phone size={15} /> {settings.phone_display}
          </a>
          <button
            className="outline-button"
            onClick={() => { track("book_now_click", { location: "navbar" }); openBooking({}); }}
            data-testid="nav-book-button"
          >
            Book now <ArrowUpRight size={14} />
          </button>
          <button className="menu-button" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="mobile-menu-button">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </header>
    </>
  );
};
